const filterItems = {
  FILTER_ITEMS_ANALYSIS_TEXT: ['FILTER_ITEMS_ANALYSIS_TEXT'] as const,
  FILTER_ITEMS_ANALYSIS_EMAIL: ['FILTER_ITEMS_ANALYSIS_EMAIL'] as const,
  FILTER_ITEMS_TEMPLATE_DETECTION: ['FILTER_ITEMS_TEMPLATE_DETECTION'] as const,
  FILTER_ITEMS_REANALYZE: ['FILTER_ITEMS_REANALYZE'] as const,
  FILTER_ITEMS_IMPORT_EMAIL: ['FILTER_ITEMS_IMPORT_EMAIL'] as const,
};

export default filterItems;
